export const sharedPagesData = [
  {
    id: 1,
    name: "Page 1",
    viewStyle: 1,
    owner: "Siddhant",
    isPinToDashboard: false,
  },
  {
    id: 2,
    name: "Page 2",
    viewStyle: 1,
    owner: "prasun",
    isPinToDashboard: false,
  },
  {
    id: 3,
    name: "Page 3",
    viewStyle: 1,
    owner: "Amrit",
    isPinToDashboard: false,
  },
  {
    id: 4,
    name: "Page 4",
    viewStyle: 1,
    owner: "Siddhant",
    isPinToDashboard: false,
  },
  {
    id: 5,
    name: "Page 5",
    viewStyle: 1,
    owner: "Amrit",
    isPinToDashboard: false,
  },
  {
    id: 6,
    name: "Page 21",
    viewStyle: 1,
    owner: "prasun",
    isPinToDashboard: false,
  },
];
